(function($) {

	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){

		var swiper = new Swiper('.widescreen-section .swiper-container', {
      grabCursor: true,
			loop: true,
			speed: 600,
			autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
			pagination: {
        el: '.swiper-pagination',
				clickable: true,
      },
    });

		var swiper = new Swiper('.news-section .swiper-container', {
			slidesPerView: 3,
      spaceBetween: 45,
			breakpoints: {
        767: {
          slidesPerView: 1,
					speed: 600,
					navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	      	},
        }
      }
    });

	});

	/* Resize functions */
	$(window).resize(function() {

		// Get Window Width and Height
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

	});

})(jQuery);
